import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AesEncryptionService {

  private secretKey = "MySuperSecretKey";   // SAME KEY AS BACKEND (16 chars → AES-128)

  /**
   * Encrypt plain text using AES/ECB/PKCS5Padding
   */
  encrypt(text: string): string {
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);

    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(text),
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return encrypted.toString(); // Base64
  }

  /**
   * Decrypt Base64 AES string from backend
   */
  decrypt(cipherText: string): string {
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);

    const decrypted = CryptoJS.AES.decrypt(
      cipherText,
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
